(function () {
    'use strict';

    function addPhase(workflowStateService, notifyService) {
        return {
            require: '^form',
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/addPhase.html',
            scope: {
                isActive: '='
            },
            link: function (scope, element, attrs, formController) {
                scope.formData = formController;
                scope.titleAndPromptModel = {
                    Value: ''
                };
                scope.siblingNames = workflowStateService.get().Phases
                    .filter(function(phase) { return !phase.IsRemoved; })
                    .map(function(phase) { return phase.Title; });

                scope.addPhase = function () {
                    // TODO: find out why ng-model isnt working in this case
                    var titleAndPrompt = scope.titleAndPromptModel.Value;
                    workflowStateService.addPhase(titleAndPrompt);
                    notifyService.notify('You added the phase ' + titleAndPrompt);  
                    scope.close();
                }

                scope.close = function() {
                    scope.titleAndPromptModel.Value = '';
                    scope.addPhaseForm.$setPristine();
                    scope.addPhaseForm.$setUntouched();
                }
            }
        };
    }

    addPhase.$inject = ['workflowStateService', 'notifyService'];

    angular.module('ecap.workflow').directive('addPhase', addPhase);
})();

